import { BsaAuthSessionXBVO } from "../model/dto.models.imported";

/**
 * Model - ResponseXBVO
 */
export class ResponseXBVO {
    code?: Number;
    error?: string;
    errorDescription?: string;
    httpStatus?: Number
}

/**
 * Model - ResponseXBVO
 */
export class TenantURL {
    tnr: string;
    url: string;
    prefix: string;

    /**
     * Factory method.
     * @param aTnr
     * @param aURL
     */
    public static create(aTnr: string, aURL: string): TenantURL {
        let pNew = new TenantURL();
        pNew.tnr = aTnr;
        pNew.url = aURL;
        return pNew;
    }
}

/**
 * Model.
 */
export class UserModel {
    lastUsed: Date;
    authXBVO: BsaAuthSessionXBVO;

    static create(aAuthXBVO: BsaAuthSessionXBVO) {
        let pNew = new UserModel();
        pNew.lastUsed = new Date();
        pNew.authXBVO = aAuthXBVO
        return pNew;
    }
}

/**
 * Class.
 */
export class EventDto {
    eventType: string;
    eventValue: any;

    /**
     * Constructor.
     * @param aEventType
     * @param aEventValue
     */
    constructor(aEventType: string, aEventValue: any) {
        this.eventType = aEventType;
        this.eventValue = aEventValue;
    }
}
